import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ssnRecord from "./SsnRecord";
import deceasedRecord from "./DeceasedRecord";

class SsnResult extends Component {
  constructor(props) {
    super(props);
    let ssnResNodes = null;
    let nimbusSsnResNodes = null;
    if (
      props.searchResultData !== undefined &&
      props.searchResultData !== null &&
      props.searchResultData !== ""
    ) {
      if (_.get(props.searchResultData, "response.output[0].people[0]") !== undefined)
        nimbusSsnResNodes = _.get(
          props.searchResultData,
          "response.output[0].people[0].person[0]"
        );
      else
        ssnResNodes = _.get(
          props.searchResultData,
          "ssnverifys.response[0].result"
        );
    }
    this.state = { ssnResNodes, nimbusSsnResNodes };
  }
  render() {
    const { ssnResNodes, nimbusSsnResNodes } = this.state;
    if (ssnResNodes === null && nimbusSsnResNodes === null) {
      return null;
    }
    if (ssnResNodes === undefined
      || nimbusSsnResNodes === undefined) {
      return <div>No Records Found</div>;
    }

    const results = [];
    const { userAccount } = this.props;
    const handleNewSearchClick = this.props.handleNewSearchClick;
    if (nimbusSsnResNodes) {
      const result = _.get(nimbusSsnResNodes, "SSNRecords[0].SSNRecord[0]");
      results.push(
        ssnRecord({ result, index: 0, handleNewSearchClick, userAccount })
      );
    } else {
      _.forEach(this.state.ssnResNodes, (result, index) => {
        if (
          _.get(result, "$.status") === "DECEASED" &&
          _.get(result, "decesed[0]") !== undefined
        ) {
          results.push(deceasedRecord({ result, index, userAccount }));
        } else {
          results.push(
            ssnRecord({ result, index, handleNewSearchClick, userAccount })
          );
        }
      });
    }
    return <div>{results}</div>;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(SsnResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/SsnResult.js